var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCompanySize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#EDE4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D8C2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1673 17.5002C24.1673 21.1821 21.1825 24.1668 17.5007 24.1668M24.1673 17.5002C24.1673 13.8183 21.1825 10.8335 17.5007 10.8335M24.1673 17.5002H21.5007M17.5007 24.1668C13.8188 24.1668 10.834 21.1821 10.834 17.5002M17.5007 24.1668V21.5002M10.834 17.5002C10.834 13.8183 13.8188 10.8335 17.5007 10.8335M10.834 17.5002H13.5007M17.5007 10.8335V13.5002",
    stroke: "#5B1AD1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCompanySize);
export default __webpack_public_path__ + "static/media/circle_company_size.36a2dc5d5581e944ed4237f528460001.svg";
export { ForwardRef as ReactComponent };